// Function loadArticleGallery loads the ArticleGallery class by dynamically importing the js on demand if needed

export function loadArticleGallery($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="ArticleGallery"]');

	if(!$wg) {
		// console.info('ArticleGallery: no widget found');
		return Promise.reject('ArticleGallery widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-article-gallery-chunk" */ '../widgets/articleGallery').then(wg => {

		const { ArticleGallery } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ArticleGallery"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ArticleGallery($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ArticleGallery($wg);
		}


	}).catch(error => error+'An error occurred while loading the ArticleGallery widget');

}
